import { useLang } from '@/i18n';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import EfIcon from '@elem/ui/ef-icon';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionF');
    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection
                pc="https://websiteoss.ecoflow.com/upload/image/1724657138625/sectionF.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724571513329/sectionF_h5.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
                hasAnimation={false}
                fixedElement={<EfIcon pc="https://websiteoss.ecoflow.com/upload/image/1724658141925/x_boost_icon.png" />}
            />
            <EfSpec />
        </div>
    );
}
